import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { LimitOrder, AllowanceTarget, Market, Protocol } from '@tokenlon/sdk';
import { useWeb3React } from '@web3-react/core';
import { useCallback, useMemo } from 'react';
import { useUpdaterChainId } from "../../hooks";
import { captureExceptionWithLabel } from "../../utils/captureExceptionWithLabel";
import { limitSwapTokenWrapper, spotSwapTokenWrapper } from "../../utils/token";
import { useAppSelector } from "../hooks";
export var useSpotSwapTokens = function useSpotSwapTokens(targetChainId) {
  var _useWeb3React = useWeb3React(),
      chainId = _useWeb3React.chainId;

  var tokens = useAppSelector(function (state) {
    return state.dex.spotTokens[targetChainId || chainId] || {};
  });
  var customTokens = useAppSelector(function (state) {
    return state.dex.userCustomSpotTokens[targetChainId || chainId] || {};
  });
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, tokens), customTokens);
  }, [tokens, customTokens]);
};
export var useLimitSwapTokens = function useLimitSwapTokens(targetChainId) {
  var _useWeb3React2 = useWeb3React(),
      chainId = _useWeb3React2.chainId;

  var tokens = useAppSelector(function (state) {
    return state.dex.limitTokens[targetChainId || chainId] || {};
  });
  var customTokens = useAppSelector(function (state) {
    return state.dex.userCustomLimitTokens[targetChainId || chainId] || {};
  });
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, tokens), customTokens);
  }, [tokens, customTokens]);
};
export var useTokenlonConfig = function useTokenlonConfig() {
  var _useWeb3React3 = useWeb3React(),
      chainId = _useWeb3React3.chainId;

  return useAppSelector(function (state) {
    return state.dex.config[chainId] || {};
  });
};
export var useSpotSwapTokensUpdater = function useSpotSwapTokensUpdater() {
  var chainId = useUpdaterChainId();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var market, tokens;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (chainId) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            market = new Market(chainId);
            _context.prev = 3;
            _context.next = 6;
            return market.getTradableTokens([Protocol.AMMV1, Protocol.AMMV2, Protocol.RFQV2, Protocol.RFQV1]);

          case 6:
            tokens = _context.sent;
            return _context.abrupt("return", spotSwapTokenWrapper(tokens || []));

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            captureExceptionWithLabel('useSpotSwapTokensUpdater Error', _context.t0);
            console.error(_context.t0);
            return _context.abrupt("return", []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  })), [chainId]);
};
export var useLimitSwapTokensUpdater = function useLimitSwapTokensUpdater() {
  var chainId = useUpdaterChainId();
  return useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var tokens;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (chainId) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            _context2.next = 5;
            return LimitOrder.getTokenList(chainId);

          case 5:
            tokens = _context2.sent;
            return _context2.abrupt("return", limitSwapTokenWrapper(tokens || []));

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            captureExceptionWithLabel('useLimitSwapTokensUpdater Error', _context2.t0);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  })), [chainId]);
};
export var useAllowanceTarget = function useAllowanceTarget() {
  var _useTokenlonConfig = useTokenlonConfig(),
      addressBookV5 = _useTokenlonConfig.addressBookV5;

  var _useWeb3React4 = useWeb3React(),
      chainId = _useWeb3React4.chainId;

  return useMemo(function () {
    return AllowanceTarget[chainId] || (addressBookV5 === null || addressBookV5 === void 0 ? void 0 : addressBookV5.AllowanceTarget);
  }, [addressBookV5, chainId]);
};
export var useLimitSwapPair = function useLimitSwapPair() {
  return useAppSelector(function (state) {
    return state.dex.limitSwapPair || [];
  });
};
export var useSpotSwapPair = function useSpotSwapPair() {
  return useAppSelector(function (state) {
    return state.dex.spotSwapPair || [];
  });
};
export var useSpotSwapAmount = function useSpotSwapAmount() {
  var inputAmount = useAppSelector(function (state) {
    return state.dex.spotSwapInputAmount;
  });
  var outputAmount = useAppSelector(function (state) {
    return state.dex.spotSwapOutputAmount;
  });
  return {
    inputAmount: inputAmount,
    outputAmount: outputAmount
  };
};
export var useLimitSwapAmount = function useLimitSwapAmount() {
  var inputAmount = useAppSelector(function (state) {
    return state.dex.limitSwapInputAmount;
  });
  var outputAmount = useAppSelector(function (state) {
    return state.dex.limitSwapOutputAmount;
  });
  return {
    inputAmount: inputAmount,
    outputAmount: outputAmount
  };
};
export var useInputAmountVerify = function useInputAmountVerify() {
  return useCallback(function (value, direction) {
    if (value === '00') return false;
    var reg = new RegExp(/^\d*\.?\d*$/);

    if (!reg.test(value) || value.trim().length === 0) {
      console.log('Invalid input amount');
      return false;
    }

    return true;
  }, []);
};
export var useLimitOrderSubmitStatus = function useLimitOrderSubmitStatus() {
  return useAppSelector(function (state) {
    return state.dex.limitOrderSubmitStatus;
  });
};
export var useLimitOrderUserConfig = function useLimitOrderUserConfig() {
  return useAppSelector(function (state) {
    return state.dex.limitOrderUserConfig;
  });
};
export var useSpotSwapUserConfig = function useSpotSwapUserConfig() {
  return useAppSelector(function (state) {
    return state.dex.spotSwapUserConfig;
  });
};
export var useIsDisableTrade = function useIsDisableTrade() {
  return useAppSelector(function (state) {
    return state.dex.isDisableTrade;
  });
};